/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TipoPraticaDTO } from './tipo-pratica-dto';
import { OrphanWarningDTO } from './orphan-warning-dto';


export interface TipoPraticaStatoTransitionResponseDTO { 
    tipo_pratica?: TipoPraticaDTO;
    warnings?: Array<OrphanWarningDTO>;
}

